import React, { FunctionComponent } from 'react';

import { DataLayerViewItemsWrapper } from 'src/components/data-layer-wrapper/data-layer-view-items-wrapper';
import { ProductSelectCard } from 'src/components/product-select-card';
import { i18n } from 'src/i18n';
import { selectProductsOrThrow } from 'src/state/request/selectors';
import { useAppSelector } from 'src/state/thunk-api';

import { StyledContainer, StyledProducts, StyledSubtitle, StyledTitle } from './page-product-select.styled';

export const PageProductSelect: FunctionComponent = () => {
  const products = useAppSelector(selectProductsOrThrow);

  return (
    <DataLayerViewItemsWrapper products={products}>
      <StyledContainer>
        <StyledTitle variant="headline2" component="h1">
          {i18n.page.productSelect.title}
        </StyledTitle>
        {products.length > 1 && (
          <StyledSubtitle variant="headline4" component="h2">
            {i18n.page.productSelect.subtitle}
          </StyledSubtitle>
        )}
        <StyledProducts>
          {products.map((product) => (
            <ProductSelectCard key={product.key} product={product} />
          ))}
        </StyledProducts>
      </StyledContainer>
    </DataLayerViewItemsWrapper>
  );
};
